<mat-drawer-container class="w-full" autosize>

    <mat-drawer #drawer class="example-sidenav " mode="side">
  
      <button class="btn btn-outline m-5 w-72" (click)="addCompanyModal()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        Create Company
      </button>
  
      <div class="bg-white px-5">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <!-- Node templates -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
  
            <!-- for spacing -->
            <button mat-icon-button *ngIf="node.nodeLevel == 'Platform'">
            </button>
  
            <button mat-icon-button *ngIf="node.nodeLevel != 'Platform'" matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
  
            <ng-container *ngIf="node.nodeLevel == 'Platform' || node.nodeLevel == 'Field'">
              <ng-container *ngTemplateOutlet="node.nodeLevel == 'Platform' ? platformIcon : fieldIcon "></ng-container>
            </ng-container>
  
            <ng-container *ngIf="node.nodeLevel == 'Company' || node.nodeLevel == 'Region'">
              <mat-icon [svgIcon]="getIcon(node.nodeLevel)" class="mr-3"></mat-icon>
            </ng-container>
  
            <div class="w-full" (mouseenter)="showDeleteButton=true" (mouseleave)="showDeleteButton=false">
              <div class="w-full flex-row items-center mr-10 node" [ngClass]="{'selectedNode': node.id == selectedNode.id }">
                <button class="node-button" (click)="pressTree(node)">
                  {{ node.longName || node.name }}
                </button>
            
                <!-- delete button -->
                <button class="px-3 delete-button" *ngIf="showDeleteButton || node.id == selectedNode.id" (click)="deleteNode(node)">
                  <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:trash'" style="color: rgb(235, 132, 132);"></mat-icon>
                </button>
              </div>
            </div>
            
          </mat-tree-node>
        </mat-tree>
      </div>
    </mat-drawer>
  
    <div class="example-sidenav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-container>
  
  <ng-template #platformIcon>
    <div style="margin-right: 10px;">
  
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="45" height="35" viewBox="0 0 173.000000 158.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,158.000000) scale(0.100000,-0.100000)" fill="#64748b" stroke="none">
          <path d="M856 1268 c-13 -84 -18 -230 -7 -224 6 4 11 19 11 34 l0 26 33 -32
    c59 -58 64 -49 50 91 -6 67 -12 125 -12 130 -1 4 -17 7 -36 7 -31 0 -35 -3
    -39 -32z m58 6 c9 -24 7 -28 -9 -14 -17 14 -20 30 -6 30 5 0 12 -7 15 -16z
    m-4 -64 c0 -9 -9 -25 -20 -35 -20 -18 -20 -17 -20 35 0 52 0 53 20 35 11 -10
    20 -26 20 -35z m18 -93 l-3 -45 -28 24 -28 24 23 30 c28 38 40 26 36 -33z" />
          <path d="M1452 1231 c-9 -9 -35 -43 -57 -74 -37 -53 -54 -66 -205 -152 -197
    -113 -196 -112 -188 -120 3 -3 69 31 148 75 78 45 144 79 146 77 3 -3 -45 -70
    -106 -150 -60 -80 -110 -148 -110 -151 0 -17 21 -1 45 34 15 22 31 40 35 40 4
    0 14 -18 23 -40 28 -73 40 -61 198 208 110 186 152 248 168 250 41 6 21 20
    -30 20 -35 1 -55 -4 -67 -17z m48 -6 c0 -4 -7 -20 -17 -38 -15 -29 -17 -30
    -23 -12 -9 24 5 55 25 55 8 0 15 -2 15 -5z m-60 -79 c0 -17 -7 -25 -25 -28
    -30 -6 -30 -4 -7 27 22 31 32 31 32 1z m-31 -86 c-16 -28 -25 -36 -31 -28 -14
    23 -9 56 10 61 41 11 43 7 21 -33z m-49 -39 c0 -24 -5 -30 -32 -35 -17 -3 -33
    -5 -34 -3 -7 7 49 76 57 71 5 -3 9 -18 9 -33z m-10 -57 c0 -4 -10 -22 -22 -42
    -20 -32 -22 -33 -35 -16 -20 27 -16 52 10 57 37 7 47 7 47 1z m-74 -72 c5 -25
    3 -32 -8 -32 -9 0 -30 -3 -49 -7 l-33 -6 34 47 c36 49 46 49 56 -2z m-6 -59
    c0 -3 -12 -27 -27 -52 l-26 -45 -18 39 c-23 52 -23 53 4 58 37 7 67 7 67 0z" />
          <path d="M807 1013 c-4 -3 -7 -33 -7 -65 l0 -58 -140 0 -140 0 0 -80 0 -80
    225 0 225 0 0 145 0 145 -78 0 c-43 0 -82 -3 -85 -7z m123 -213 c0 -6 -42 -10
    -105 -10 -63 0 -105 4 -105 10 0 6 42 10 105 10 63 0 105 -4 105 -10z" />
          <path d="M220 980 c0 -6 42 -10 105 -10 l105 0 0 -30 c0 -28 3 -30 35 -30 32
    0 35 2 35 30 0 17 5 30 10 30 6 0 10 5 10 10 0 6 -57 10 -150 10 -93 0 -150
    -4 -150 -10z" />
          <path d="M320 745 l0 -145 90 0 90 0 0 145 0 145 -90 0 -90 0 0 -145z m70 -6
    c0 -24 -4 -38 -10 -34 -17 10 -11 75 7 75 2 0 3 -18 3 -41z m50 0 c0 -24 -4
    -38 -10 -34 -5 3 -10 22 -10 41 0 19 5 34 10 34 6 0 10 -18 10 -41z" />
          <path d="M518 655 l-3 -55 348 0 347 0 0 55 0 55 -344 0 -344 0 -4 -55z m329
    -12 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m63 12 c0 -14 -4
    -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 25 10 25 6 0 10 -11 10 -25z m40 0 c0
    -14 -4 -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 25 10 25 6 0 10 -11 10 -25z
    m47 -12 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z" />
          <path d="M450 572 c0 -5 9 -35 20 -67 11 -32 20 -82 20 -112 l0 -53 -45 0
    c-25 0 -45 -4 -45 -10 0 -6 80 -10 220 -10 140 0 220 4 220 10 0 6 -57 10
    -150 10 l-150 0 0 53 c0 30 9 80 20 112 11 32 20 62 20 67 0 4 -29 8 -65 8
    -36 0 -65 -4 -65 -8z" />
          <path d="M952 568 c32 -85 49 -154 46 -185 l-3 -38 -55 -3 c-30 -2 -59 -7 -64
    -13 -6 -5 95 -9 272 -9 181 0 282 4 282 10 0 6 -72 10 -195 10 l-195 0 0 53
    c0 29 11 82 24 120 l24 67 -70 0 c-52 0 -69 -3 -66 -12z" />
          <path d="M240 330 c0 -6 29 -10 66 -10 41 0 63 4 59 10 -3 6 -33 10 -66 10
    -33 0 -59 -4 -59 -10z" />
          <path d="M523 288 c-2 -5 37 -8 88 -8 51 0 89 3 86 6 -9 10 -168 11 -174 2z" />
          <path d="M742 288 c-9 -4 79 -7 197 -7 118 -1 212 2 209 5 -9 8 -386 10 -406
    2z" />
        </g>
      </svg>
    </div>
  </ng-template>
  
  <ng-template #fieldIcon>
    <div style="margin-right: 10px;">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30" height="35" viewBox="0 0 282.000000 268.000000"
        preserveAspectRatio="xMidYMid meet">
  
        <g transform="translate(0.000000,268.000000) scale(0.100000,-0.100000)" fill="#64748b" stroke="none">
          <path d="M1191 2524 c-183 -49 -338 -204 -386 -385 -22 -80 -19 -198 6 -272
   33 -98 111 -242 212 -390 96 -141 294 -397 307 -397 14 0 212 256 311 402 105
   156 175 286 208 386 25 73 28 191 6 271 -48 183 -204 337 -391 386 -72 19
   -201 18 -273 -1z m268 -311 c67 -34 115 -94 137 -170 42 -144 -44 -296 -193
   -339 -234 -68 -434 191 -313 403 75 131 232 176 369 106z" />
          <path d="M290 1065 l0 -805 1040 0 1040 0 0 805 0 805 -239 0 c-219 0 -239 -1
   -244 -17 -2 -10 -8 -26 -12 -35 -7 -17 7 -18 209 -18 l216 0 0 -735 0 -735
   -970 0 -970 0 0 735 0 735 216 0 c202 0 216 1 209 18 -4 9 -10 25 -12 35 -5
   16 -25 17 -244 17 l-239 0 0 -805z" />
          <path d="M450 1070 l0 -660 880 0 880 0 0 660 0 660 -184 0 -184 0 -21 -34
   c-12 -18 -21 -36 -21 -40 0 -3 29 -6 64 -6 l64 0 -5 -59 c-5 -53 -2 -65 28
   -119 l33 -60 -57 -84 c-65 -97 -87 -145 -87 -187 0 -34 6 -39 80 -66 52 -19
   55 -22 62 -64 11 -64 42 -121 103 -189 l55 -60 0 -141 0 -141 -600 0 -600 0
   -14 32 c-8 18 -35 62 -60 97 -25 36 -46 73 -46 83 0 11 -11 30 -25 44 -23 23
   -32 25 -87 22 -58 -3 -63 -1 -75 22 -6 14 -15 37 -17 51 -5 25 -18 33 -78 53
   -17 5 -18 32 -18 386 l0 380 170 0 c94 0 170 2 170 4 0 3 -9 21 -21 40 l-21
   36 -184 0 -184 0 0 -660z" />
          <path d="M1512 1233 c-50 -65 -111 -140 -135 -168 -41 -46 -46 -48 -62 -35
   -10 8 -68 77 -128 153 -106 133 -110 137 -131 122 -18 -13 -72 -44 -188 -108
   -40 -23 -78 -87 -85 -144 -13 -112 42 -192 192 -283 103 -62 120 -63 281 -10
   152 49 181 50 248 8 40 -27 61 -33 103 -33 44 0 56 5 83 30 70 67 76 142 25
   289 -19 55 -35 118 -35 141 0 42 -45 146 -66 152 -6 2 -52 -50 -102 -114z" />
        </g>
      </svg>
    </div>
  </ng-template>